"use client"

import { Rarible } from "@/app/content-blocks/rarible/rarible"
import { useEffect, useState } from "react"

interface DelayedRaribleProps {
  className?: string
  delayMs?: number
}

export function DelayedRarible({
  className,
  delayMs = 2000,
}: DelayedRaribleProps) {
  const [shouldRender, setShouldRender] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldRender(true)
    }, delayMs)

    return () => clearTimeout(timer)
  }, [delayMs])

  if (!shouldRender) {
    return null
  }

  return <Rarible className={className} />
}
